<div class="container">
	<div class="row">
		<div class="col">
			<div class="row text-center">
				<div class="col">
					<label for="otpInput">{{'ENTER_OTP' | translate}}</label>
				</div>
			</div>
			<div class="row text-center">
				<div class="col">
					<div class="form-group">
						<div class="otp-outer mb-3">
							<div class="otp-inner">
								<input type="text" maxlength="5" class="form-control partitioned" id="otpInput" name="otp" aria-describedby="otpHelp" [(ngModel)]="otp"
									oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"  
									onKeyPress="if(this.value.length==5) return false;"
									autofocus>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="row button-row">
				<div class="col">
					<button type="button" class="btn btn-primary" (click)="previousStep()">Back</button>
				</div>
				<div class="col">
					
					<button type="button" class="btn btn-primary float-right" (click)="nextStep()">Next</button>
				</div>
			</div> -->
		</div>
	</div>
	<div class="row button-row">
		<div class="col">
			<button type="button" class="btn btn-primary float-end" (click)="previousStep()">{{'BACK' | translate}}</button>
		</div>
		<div class="col">
			<button class="btn btn-primary float-end" (click)="resendOtp()" [disabled]="resendingOtp">{{resendOtpButtonText}}</button>
		</div>
		<div class="col">
			<button type="button" class="btn btn-primary float-start" (click)="nextStep()">{{'NEXT' | translate}}</button>
		</div>
	</div>
</div>
